export const TRANSLATIONS_RU = {
    signupTitle: "Регистрация",
    signupHeader: "Пожалуйста, введите следующую информацию, чтобы создать учетную запись.",
    mobileNumber: "Номер мобильного телефона",
    patientFirstname: "Имя пациента",
    patientLastName: "Фамилия пациента",
    firstName: "Имя",
    lastName: "Фамилия",
    enterFirstName: "Введите ваше имя",
    enterLastName: "Введите вашу фамилию",
    tellUsAboutYourself: "Расскажите нам о себе",
    fewDetailsToGetStarted: "Нужно всего несколько деталей, чтобы начать",
    gender: "Пол",
    patientDob: "Дата рождения пациента",
    patientGender: "Пол пациента",
    male: "Мужской",
    female: "Женский",
    zipCode: "Почтовый индекс",
    password: "Пароль",
    whoIsFillingForm: "Кто заполняет эту форму?",
    legalGuardian: "Опекун",
    patient: "Пациент",
    proceedButton: "Продолжить",
    belowTwelveNote: "Учитывая ваш возраст, нам нужно участие родителя. Пожалуйста, передайте устройство родителю или попросите его зарегистрироваться.",
    parent: "Да, я родитель",
    notParent: "Нет, я не родитель",
    twelveToEighteenNote: "Учитывая возраст пациента, нам нужно его участие. Пожалуйста, передайте устройство пациенту для регистрации, если он может ответить на опрос.",
    imPatient: "Да, я пациент",
    notPatient: "Нет, я не пациент",
    patientIncapable: "Пациент не может ответить",
    legalGuardianTitle: "Введите ваши данные",
    guardianFirstName: "Имя опекуна",
    guardianLastName: "Фамилия опекуна",
    guardianEmail: "Адрес электронной почты",
    emergencyContactTitle: "Введите данные вашего контакта на случай экстренной ситуации",
    emergencyFirstName: "Имя",
    emergencyLastName: "Фамилия",
    emergencyPhoneNumber: "Номер телефона",
    relationType: "Тип отношения",
    canShareDetail: "В случае экстренной ситуации можем ли мы поделиться вашими данными с указанным выше контактным лицом",
    yes: "Да",
    no: "Нет",
    reasonForVisitTitle: "Причина визита",
    sickVisit: "Визит по болезни",
    annualVisit: "Ежегодный осмотр",
    welcomeTitle: "Введение к анкете",
    welcomeSubTitle: "Пожалуйста, укажите любые симптомы, ответив на следующие вопросы. Это займет 8-10 минут вашего времени.",
    getStartedButton: "Начать",
    adhdNote: "Следующий опрос должен быть заполнен вашим законным опекуном или родителем. Пожалуйста, передайте устройство.",
    handoverButton: "Передать",
    loginTitle: "Вход",
    loginSubTitle: "Ваша информация останется защищенной и конфиденциальной.",
    forgotPassword: "Забыли пароль?",
    forgotPasswordSubTitle: "Пожалуйста, введите номер телефона, который вы используете для входа в Small Joys",
    backToLogin: "Вернуться ко входу",
    resetPassword: "Сбросить пароль",
    resetPasswordSubTitle: "Пожалуйста, создайте новый пароль. Он должен содержать не менее 8 символов",
    enterCodeTitle: "Пожалуйста, введите OTP, отправленный на",
    change: "Изменить",
    verify: "Подтвердить",
    notReceivedCode: "Не получили код?",
    resendCode: "Отправить код повторно",
    completedScreener: "Вы завершили анкетирование",
    nextScreener: "Перейти к следующему анкетированию",
    thankYou: "Спасибо!",
    completedQuestionnaires: "Вы завершили все анкеты.",
    handover: "Пожалуйста, передайте устройство администратору",
    suicidalTitle: "Вам нужно поговорить с кем-то сегодня",
    suicidalSubTitle: "Если вы думаете о том, чтобы причинить себе вред, беспокоитесь о друге или близком человеке, или вам нужна эмоциональная поддержка, позвоните нам и поговорите с нами (мы доступны 24/7)",
    call: "Позвонить",
    officialWebsite: "Официальный сайт",
    oneDrinkEquals: "Один напиток равен",
    ozBeer: "унц. пива",
    ozWine: "унц. вина",
    ozLiquor: "унц. крепкого алкоголя",
    ozLiquorOneShot: "одна рюмка"
}
